<template>
    <div class="relative">
    <Modal :icon="icon" @close="openCloseModal"/>
      <StickyNav :class="visibleClassFive"/>
      <Hero :icon="icon" @watchVideo="openCloseModal" />
      <main 
          v-intersection="{
              handler: onIntersection,
              cfg: {
                root: null, 
                rootMargin: '0px 0px -50% 0px',
                threshold: 0
          }}">
      <Deadline />
      <Overview id="overview"/>
      <Theme id="themes"/>
      <SessionFormat id="session-format" />
      <Keynotes id="keynote" />
      <Timeline id="key-dates" />
      <location />
      </main>
    </div>
</template>

<script setup>

  import Nav from '../components/Nav.vue'
  import Card from '../components/Card.vue'
  import StickyNav from '../components/StickyNav.vue'
  import Hero from '../components/Hero.vue'
  import Theme from '../components/Theme.vue'
  import Deadline from '../components/Deadline.vue'
  import Overview from '../components/Overview.vue'
  import Keynotes from '../components/Keynotes.vue'
  import Timeline from '../components/Timeline.vue'
  import SessionFormat from '../components/SessionFormat.vue'
  import Location from '../components/Location.vue'
  import EdTech from '../components/EdTech.vue'
  import Modal from '../components/Modal.vue'
  import { scroll } from 'quasar'
  import { ref } from 'vue'
  import { computed } from 'vue'

  const { getScrollTarget } = scroll

  const visible = ref(false)

  const icon = ref(false)

  const openCloseModal = () => {
    icon.value = !icon.value
  }
      
  const onIntersection = (entry) => {
      const mediaQuery = window.matchMedia('(min-width: 900px)')
      mediaQuery.matches ? visible.value = entry.isIntersecting : visible.value = false 
  }

  const visibleClassFive = computed(() => { 
    if(visible.value) {
        return 'sticky-nav'
      } else {
        return 'hide-nav'
      }
  })

</script>

